var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoDxColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400.39 111.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#cd1719;}.cls-2{fill:#fff;}.cls-3{fill:#fab31e;}.cls-4{fill:#ffd500;}.cls-5{fill:#004996;}.cls-6{fill:#008e5a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M168.79,90.6h11.3c13.8,0,20.1-10.7,20.1-32.8,0-12.2-1.1-22.4-5.3-29.3-3.5-5.7-8.3-8.7-16.5-8.7h-9.6Zm-.3-87.3c6,0,14,.3,18.2.6a35.55,35.55,0,0,1,22.8,10.4c9.6,9.5,14.3,22.8,14.3,41.6,0,14.3-3.5,26.7-10.5,36.2-6.3,8.6-15.6,14.3-25.4,15-3.9.3-8.9.6-15,.6h-25.4V3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.59,65.5s-3.5-11-5.7-21c-1.1-4.8-4.2-18.5-4.2-18.5s-3,12.3-5,20.1c-2,7.5-3.3,12.5-5.6,19.4ZM291.69,3l32.9,104.7h-22.5l-7.4-24.8H264l-7.4,24.8h-21.9L269,3h22.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "400.39 3.3 396.89 20.7 372 20.7 372 107.7 350.6 107.7 350.6 20.7 325.1 20.7 325.1 3.3 400.39 3.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.79,55.8A55.8,55.8,0,1,1,56,0a55.82,55.82,0,0,1,55.8,55.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M72.19,54.1a153.28,153.28,0,0,1,18.5,16.8c4.3-1.8,12.9-5.1,20.3-6.3a56.42,56.42,0,0,0-4.3-31.9L72.19,54.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M92.19,98.2a55,55,0,0,0,9.4-10.4,57,57,0,0,0,6.6-12.4L97,84.6l-4.8,13.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M82,83.4a157,157,0,0,1-22.1-11.7l-8.3,39.7A55.5,55.5,0,0,0,83,104.6c-1.4-7.4-1.2-16.6-1-21.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.89,108.1c-1.5-1.9,0-39.9.4-49.8-19-14.4-31.3-29.9-30.5-34a55.75,55.75,0,0,0,32,85.5c-.8-.7-1.5-1.3-1.9-1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M52.89,40.3C62,36.5,97.19,22,99.49,22.9a17.42,17.42,0,0,1,2.3,1.2,55.76,55.76,0,0,0-91.3-.7c3.6-2.2,22.4,4,42.4,16.9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDxColor);
export default __webpack_public_path__ + "static/media/logoDXColor.027cca6a0ca357bc5ddea42c7d7bd737.svg";
export { ForwardRef as ReactComponent };